import { COUNTRIES_GET } from "../actionNames/Countries";

export function countriesGet(data) {
  return { type: COUNTRIES_GET, data };
}
